import CardConfig from 'components/CardConfig';
import { formatDate } from 'components/helper/helper';
import DatePickerInput from 'components/input/DatePicker';
import GroupRadioButton from 'components/input/GroupRadioButton';
import { useFormik } from 'formik';
import React from 'react';


export interface MilitaryBranch {
  branch: string;
  startDate: string;
  endDate: string;
} 
interface Props {
  index: number;
  item: MilitaryBranch;
  handleSave: (value: any) => void;
  disabled?: boolean;
};

const MilitaryConfig = (props: Props) => {
  const { disabled = false } = props;
  const initForm = (item: MilitaryBranch) => {
    if (item) {
      return {
        branch: item?.branch ?? '',
        startDate: item?.startDate ?? '',
        endDate: item?.endDate  ?? ''  
      };
    }
    else {
      return {
        branch: '',
        startDate: '',
        endDate: '',
      };
    }
  }
  const formik = useFormik({
    initialValues: initForm(props.item),
    onSubmit: (values) => {},
  });

  React.useEffect(() => {
    if (formik.dirty) {
      props.handleSave(formik.values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values]);

  const buldTitle = () => {
    const title = [];
    if (formik.values.branch) {
      title.push(formik.values.branch);
    }

    if(!formik.values.startDate) {
      title.push('-');
    } else {
      title.push(formatDate(formik.values.startDate));
    }

    if(!formik.values.endDate) {
      title.push('to', '-');
    } else {
      title.push('to', formatDate(formik.values.endDate));
    }
    return title.join(' ');
  }
  return (
    <CardConfig
      onExpandClick={() => {}}
      headerElement={
        <>
          <span className="p-1">
            {buldTitle()}
          </span>
        </>
      }
      handleSave={() => {
        props.handleSave(formik.values);
      }}
    >
      <div>Branch</div>
      <GroupRadioButton
        columns={3}
        mdCol={6}
        options={[
          { value: 'Air Force' },
          { value: 'Army' },
          { value: 'Coast Guard' },
          { value: 'Marine Corps' },
          { value: 'Navy' },
        ]}
        name="branch"
        values={formik.values.branch}
        onChange={formik.handleChange}
        disabled={disabled}
      />
      <div />
      <DatePickerInput
        label="Service Start Date"
        name="startDate"
        values={formik.values.startDate}
        onChange={(value) => formik.setFieldValue('startDate', value)}
        disabled={disabled}
      />
      <div className='my-3'>
      <DatePickerInput
        label="Actual or Projected Service end date"
        name="endDate"
        values={formik.values.endDate}
        onChange={(value) => formik.setFieldValue('endDate', value)}
        disabled={disabled}
      />
      </div>
    </CardConfig>
  );
};

export default MilitaryConfig;
